export default "/images/a4f4a421eee4e49d4041335fc51a7912.avif";